<style scoped>
.content-wrapper .content {
    padding-top: 95px !important;
}
.creative-save-btn {
    clear: both;
    text-align: right;
    margin-right: 30px;
}
.capitalize {
    text-transform: capitalize;
}
</style>
<style>
.capitalize input {
    text-transform: capitalize;
}
.vue-swatches__row {
    height: 24px;
}
.vue-swatches__trigger {
    border: 1px solid #d8dce5;
}
.of-auto {
    clear: both;
}
.of-auto h5 {
    line-height: inherit;
}
.el-collapse-item__wrap {
    width: 100%;
}

.bidder-params-box {
    border: 2px solid #3c8dbc;
    margin: 20px auto;
}

/*.box-body{

padding: 0px 30px !important;
    }*/
.recentlyClosed {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.opened {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.notChart {
    text-align: center;
    vertical-align: middle;
    line-height: 250px;
    color: red;
}

.forcontract {
    padding: 16px 18px;
    /* background: #6767e2e0;*/
    /* color: white;  */
}

.enabled-bidders {
    max-height: 50px;
    display: inline-flex;
}

.enabled-bidders p {
    display: inline;
    background: #8b85e5;
    margin: 0 5px;
    padding: 2px;
    border-radius: 3px;
    color: #18171a;
}

.collapse--item {
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.collapse--item:first-child {
    margin-top: 10px;
}

.el-collapse-item__wrap {
    width: 100%;
}
.isSuspendedTrueClass {
    border: 1px solid black;
    padding: 15px;
    background: rgba(252, 121, 116, 0.2);
    margin-bottom: 10px;
    padding-right: 0;
}
.isSuspendedFalseClass {
    border: 1px solid black;
    padding: 15px;
    background: #f0eef5;
    margin-bottom: 10px;
    padding-right: 0;
}

div[role='tabpanel'] {
    width: 100%;
}
.line-item-dialog .el-dialog__body {
    padding-top: 15px;
}

.el-collapse-item__wrap {
    width: 100%;
}
.lineItemContainerHidden {
    display: none;
}
.lineItemContainerBlock {
    display: block;
}
.firstelm {
    display: inline-block;
    width: 12.5%;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border" style="display: flex; padding: 0 30px 0 30px">
                    <div style="flex: auto">
                        <h3 class="box-title">
                            <div v-if="siteDetails.url">
                                Line Items For the Domain:
                                <a
                                    v-bind:href="siteDetails.url"
                                    target="_blank"
                                    style="font-weight: bold; font-size: 17px"
                                    >{{ siteDetails.url }}</a
                                >
                            </div>
                        </h3>
                        <br />
                        <h3 class="box-title">
                            <div v-if="siteDetails.publisher">
                                Publisher:
                                <a style="font-weight: bold; font-size: 17px">{{ siteDetails.publisher }}</a>
                            </div>
                        </h3>
                    </div>
                    <div style="flex: none; display: flex; align-items: end">
                        <h3
                            class="box-title"
                            style="margin-top: 7px"
                            v-if="allLineItems.length > 0 && siteDetails.currency && siteDetails.currency.code"
                        >
                            RTC Currency: {{ siteDetails.currency.code }}
                        </h3>
                        <el-button
                            type="success"
                            class="pull-right"
                            @click="showExportParamas"
                            style="margin-left: 10px; margin-top: 7px"
                            >Export Params</el-button
                        >
                    </div>
                </div>
                <div class="box-body">
                    <div class="clearfix">
                        <div class="atd-tags">
                            <div class="flex-sb">
                                <h4 class="box-title">Tags:</h4>
                                <div>
                                    <el-button
                                        type="success"
                                        @click="showExportTags"
                                        :disabled="
                                            allLineItems.filter((k) => {
                                                return k.type.includes('tag');
                                            }).length == 0
                                        "
                                        class="pull-right"
                                        style="margin: 10px 0px 10px 10px"
                                        >Export Tag</el-button
                                    >
                                    <el-button
                                        type="success"
                                        @click.stop="showCreateTagDialogfunction($event)"
                                        class="pull-right"
                                        style="margin: 10px 0"
                                        >Create Tag</el-button
                                    >
                                </div>
                            </div>
                            <div
                                v-if="
                                    allLineItems.length > 0 &&
                                    allLineItems.filter((k) => {
                                        return k.type.includes('tag');
                                    }).length > 0
                                "
                            >
                                <div
                                    v-if="item.type.includes('tag')"
                                    v-for="(item, index) in allLineItems"
                                    :key="index"
                                    @click.stop.prevent="lineitemDivClick($event)"
                                >
                                    <div
                                        v-bind:class="[
                                            item.suspend || item.budget_exhausted
                                                ? 'isSuspendedTrueClass'
                                                : 'isSuspendedFalseClass',
                                        ]"
                                    >
                                        <div v-if="siteDetails && (item.type !== 'unitag' &&  siteDetails['placement_targeting_'+item.type.toLowerCase()] && item.placement_text.length == 0)"
                                            class="row" style="width:100%; display:flex;justify-content:center;color:red;"
                                        >
                                            *disabled(No placement targeting enabled)
                                        </div>
                                        <div v-if="siteDetails && siteDetails['position_targeting_'+item.type.toLowerCase()] && item.positions.length == 0"
                                            class="row" style="width:100%; display:flex;justify-content:center;color:red;"
                                        >
                                            *disabled(No position targeting enabled)
                                        </div>
                                        <div class="row" @click="lineitemHeadingClick(item)" style="cursor: pointer">
                                            <div class="col-md-2">
                                                <div style="margin-bottom: 10px; word-break: break-word">
                                                    Line item : {{ item.name }}
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div style="margin-bottom: 10px" id="litype">
                                                    Type : {{ item.type }}
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div style="margin-bottom: 10px" id="bidcpm">
                                                    Bid CPM Range : <br />{{
                                                        item.bid_cpm_min + ' $ - ' + item.bid_cpm_max + ' $'
                                                    }}
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div style="margin-bottom: 10px" id="budget">
                                                    Budget : {{ (item.budget || '') + ' $' }}
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <button
                                                    v-if="item.budget_exhausted == true"
                                                    type="success"
                                                    class="
                                                        el-button
                                                        notes-box
                                                        el-button--text el-button--small
                                                        forcontract
                                                    "
                                                    style="
                                                        background: white;
                                                        color: black;
                                                        border: 1px solid black;
                                                        padding: 10px;
                                                    "
                                                    @click="resumeExhaustedLineItem($event, item)"
                                                >
                                                    Resume
                                                </button>
                                            </div>
                                            <div class="col-md-1">
                                                <div style="margin-bottom: 10px">
                                                    <el-switch
                                                        v-model="item.active"
                                                        active-color="#13ce66"
                                                        inactive-color="#ff4949"
                                                        @change="lineitemStatus(item)"
                                                    ></el-switch>
                                                </div>
                                            </div>
                                            <div class="col-md-2 text-center">
                                                <!-- code to duplicate a line item -->
                                                <el-tooltip content="Duplicate Tag" placement="bottom">
                                                    <button
                                                        type="success"
                                                        class="el-button notes-box el-button--text el-button--small"
                                                        style="background: none; color: black"
                                                        @click="showDuplicateLineitemDialogfunction($event, item)"
                                                    >
                                                        <i
                                                            class="fa fa-copy"
                                                            aria-hidden="true"
                                                            style="font-size: 17px"
                                                        ></i>
                                                    </button>
                                                </el-tooltip>
                                            </div>
                                            <div class="col-md-2 text-center">
                                                <div style="margin-bottom: 10px; display: flex; justify-content: space-around;">
                                                    <el-tooltip content="Notes" placement="bottom">
                                                        <button
                                                            type="success"
                                                            class="el-button notes-box el-button--text el-button--small"
                                                            style="background: none; color: black"
                                                            @click="createLineItemNotes($event, item)"
                                                        >
                                                            <i
                                                                class="fa fa-sticky-note"
                                                                aria-hidden="true"
                                                                style="font-size: 17px"
                                                            ></i>
                                                        </button>
                                                    </el-tooltip>
                                                    <el-tooltip content="Edit Lineitem" placement="bottom">
                                                        <button
                                                            type="success"
                                                            class="el-button notes-box el-button--text el-button--small"
                                                            style="background: none; color: black"
                                                            @click="editLineitem($event, item)"
                                                        >
                                                            <i
                                                                class="fa fa-pencil"
                                                                aria-hidden="true"
                                                                style="font-size: 17px"
                                                            ></i>
                                                        </button>
                                                    </el-tooltip>
                                                    <button
                                                        v-if="item.suspend == true"
                                                        type="success"
                                                        class="
                                                            el-button
                                                            notes-box
                                                            el-button--text el-button--small
                                                            forcontract
                                                        "
                                                        style="
                                                            background: white;
                                                            color: black;
                                                            border: 1px solid black;
                                                            padding: 10px;
                                                        "
                                                        @click="resumeStage($event, item)"
                                                    >
                                                        Resume
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <el-tabs
                                            type="border-card"
                                            v-model="activeName"
                                            @tab-click="lineitemHeadingClick(item)"
                                        >
                                            <el-tab-pane label="Details" :name="'first_'+item.xid">
                                                <LineItemDetails
                                                    :dimensions="dimensions"
                                                    :item="item"
                                                    :devices="devices"
                                                    :browsers="browsers"
                                                    :changeItemFormat="changeItemFormat"
                                                    :countries="countries"
                                                    :creativeList="creativeList"
                                            />
                                            </el-tab-pane>
                                            <el-tab-pane label="Data" :name="'second_'+item.xid">
                                                <LineItemData :eventLoader="isEventLoading" :revenueLoader="isRevenueLoading" :eventData="tableDataEvent" :revenueData="tableDataRevenue" :currentTime="timeNow" />
                                            </el-tab-pane>
                                            <!-- <el-tab-pane label="Notes" :name="'third_'+item.xid">
                                                <line-item-notes :lineItemId="item.id"/>
                                            </el-tab-pane> -->
                                        </el-tabs>
                                    </div>
                                </div>
                            </div>
                            <div v-else>No Tags Created</div>
                        </div>
                        <div class="atd-placements">
                            <div
                                class="row"
                                style="margin: 0 0 10px 0; display: flex; align-items: center; justify-content: center"
                            >
                                <div class="col-md-6" style="padding: 0">
                                    <h4 class="box-title">Line Items:</h4>
                                    <span>No. of LineItems : {{ allLineItems.length }}</span>
                                </div>
                                <div class="col-md-6" style="padding: 0">
                                    <el-button
                                        type="success"
                                        @click.stop="showCreateLineitemDialogfunction($event)"
                                        class="pull-right"
                                        :disabled="loading"
                                        >Create Line Item</el-button
                                    >
                                </div>
                            </div>
                            <div
                                v-if="!item.type.includes('tag')"
                                v-for="item in allLineItems"
                                :key="item.id"
                                @click.stop.prevent="lineitemDivClick($event)"
                            >
                                <div
                                    v-bind:class="[
                                        item.suspend || item.budget_exhausted
                                            ? 'isSuspendedTrueClass'
                                            : 'isSuspendedFalseClass',
                                    ]"
                                >
                                    <div v-if="siteDetails && siteDetails['placement_targeting_'+item.type.toLowerCase()] && item.placement_text.length == 0 "
                                        class="row" style="width:100%; display:flex;justify-content:center;color:red;"
                                    >
                                        *disabled(No placement targeting enabled)
                                    </div>
                                    <div v-if="siteDetails && siteDetails['position_targeting_'+item.type.toLowerCase()] && item.positions.length == 0"
                                        class="row" style="width:100%; display:flex;justify-content:center;color:red;"
                                    >
                                        *disabled(No position targeting enabled)
                                    </div>
                                    <div class="row" @click="lineitemHeadingClick(item)" style="cursor: pointer">
                                        <div class="col-md-2">
                                            <div style="margin-bottom: 10px; word-break: break-word">
                                                Line item : {{ item.name }}
                                            </div>
                                        </div>
                                        <div class="col-md-1">
                                            <div style="margin-bottom: 10px" id="litype">Type : {{ item.type }}</div>
                                        </div>
                                        <div class="col-md-2">
                                            <div style="margin-bottom: 10px" id="bidcpm">
                                                Bid CPM Range : <br />
                                                {{ item.bid_cpm_min + ' $ - ' + item.bid_cpm_max + ' $' }}
                                            </div>
                                            <div></div>
                                        </div>
                                        <div class="col-md-1">
                                            <div style="margin-bottom: 10px" id="budget">
                                                Budget : {{ (item.budget || '') + ' $' }}
                                            </div>
                                        </div>
                                        <div class="col-md-1">
                                            <button
                                                v-if="item.budget_exhausted == true"
                                                type="success"
                                                class="el-button notes-box el-button--text el-button--small forcontract"
                                                style="
                                                    background: white;
                                                    color: black;
                                                    border: 1px solid black;
                                                    padding: 10px;
                                                "
                                                @click="resumeExhaustedLineItem($event, item)"
                                            >
                                                Resume
                                            </button>
                                        </div>
                                        <div class="col-md-1">
                                            <div style="margin-bottom: 10px">
                                                <el-switch
                                                    v-model="item.active"
                                                    active-color="#13ce66"
                                                    inactive-color="#ff4949"
                                                    @change="lineitemStatus(item)"
                                                ></el-switch>
                                            </div>
                                        </div>
                                        <div class="col-md-2 text-center">
                                            <!-- code to duplicate a line item -->
                                            <el-tooltip content="Duplicate Lineitem" placement="bottom">
                                                <button
                                                    type="success"
                                                    class="el-button notes-box el-button--text el-button--small"
                                                    style="background: none; color: black"
                                                    @click="showDuplicateLineitemDialogfunction($event, item)"
                                                >
                                                    <i
                                                        class="fa fa-copy"
                                                        aria-hidden="true"
                                                        style="font-size: 17px"
                                                    ></i>
                                                </button>
                                            </el-tooltip>
                                        </div>
                                        <div class="col-md-2 text-center">
                                            <div style="margin-bottom: 10px; display: flex; justify-content: space-around;">
                                                <el-tooltip content="Notes" placement="bottom">
                                                    <button
                                                        type="success"
                                                        class="el-button notes-box el-button--text el-button--small"
                                                        style="background: none; color: black"
                                                        @click="createLineItemNotes($event, item)"
                                                    >
                                                        <i
                                                            class="fa fa-sticky-note"
                                                            aria-hidden="true"
                                                            style="font-size: 17px"
                                                        ></i>
                                                    </button>
                                                </el-tooltip>
                                                <el-tooltip content="Edit Lineitem" placement="bottom">
                                                    <button
                                                        type="success"
                                                        class="el-button notes-box el-button--text el-button--small"
                                                        style="background: none; color: black"
                                                        @click="editLineitem($event, item)"
                                                    >
                                                        <i
                                                            class="fa fa-pencil"
                                                            aria-hidden="true"
                                                            style="font-size: 17px"
                                                        ></i>
                                                    </button>
                                                </el-tooltip>
                                                <button
                                                    v-if="item.suspend == true"
                                                    type="success"
                                                    class="
                                                        el-button
                                                        notes-box
                                                        el-button--text el-button--small
                                                        forcontract
                                                    "
                                                    style="
                                                        background: white;
                                                        color: black;
                                                        border: 1px solid black;
                                                        padding: 10px;
                                                    "
                                                    @click="resumeStage($event, item)"
                                                >
                                                    Resume
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-r-15">
                                        <el-tabs
                                            type="border-card"
                                            v-model="activeName"
                                            @tab-click="lineitemHeadingClick(item)"
                                        >
                                            <el-tab-pane label="Details" :name="'first_'+item.xid">
                                                <LineItemDetails
                                                    :dimensions="dimensions"
                                                    :item="item"
                                                    :devices="devices"
                                                    :browsers="browsers"
                                                    :changeItemFormat="changeItemFormat"
                                                    :countries="countries"
                                                    :creativeList="creativeList"
                                            /></el-tab-pane>
                                            <el-tab-pane label="Data" :name="'second_'+item.xid">
                                                <LineItemData :eventLoader="isEventLoading" :revenueLoader="isRevenueLoading" :eventData="tableDataEvent" :revenueData="tableDataRevenue" :currentTime="timeNow" />
                                            </el-tab-pane>
                                          <!-- <el-tab-pane label="Notes" :name="'third_'+item.xid">
                                              <line-item-notes :lineItemId="item.id"/>
                                          </el-tab-pane> -->
                                        </el-tabs>
                                    </div>
                                </div>
                            </div>
                            <div v-if="allLineItems.length == 0">
                                <h5>Line items are not created</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- notes creation block -->
        
        <el-dialog
            class="element-promt line-item-dialog"
            title= "Notes"
            :visible.sync="showCreateLineItemNotes"
            width="40%"
            :before-close="handleCloseLineItemNotes"
        >
            <line-item-notes :lineItemId="selectedItem"/>
        </el-dialog>
        <!-- line item creation/edit block -->
        <el-dialog
            class="element-promt line-item-dialog"
            title="Line item"
            :visible.sync="showCreateLineitemDialog"
            width="40%"
            :before-close="handleCloseLineitem"
        >
            <div class="p-t-1 of-auto">
                <h5>Name</h5>
                <el-input
                    v-validate="'required'"
                    data-vv-delay="1000"
                    class="col-md-12"
                    name="name"
                    type="text"
                    placeholder="Enter LineItem Name"
                    v-model="createLineItemForm.name"
                ></el-input>
                <span v-show="errors.has('name')" class="help is-danger" style="color: red">{{
                    errors.first('name')
                }}</span>
            </div>
            <div v-if="createLineItemForm.type.includes('tag')">
                <div class="p-t-1 of-auto">
                    <h5>Is Universal Tag?</h5>
                    <el-switch class="col-md-12" v-model="isUniTag"></el-switch>
                </div>
            </div>
            <div class="p-t-1 of-auto">
                <h5>Enable</h5>
                <el-switch class="col-md-12" v-model="createLineItemForm.active"></el-switch>
            </div>
            <div>
                <div class="p-t-1 of-auto">
                    <h5>Vertical:</h5>
                    <el-select class="col-md-12" v-model="createLineItemForm.vertical" placeholder="Select">
                        <el-option v-for="item in placementVertical" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="p-t-1 of-auto" v-if="!createLineItemForm.type.includes('tag')">
                <h5>Type:</h5>
                <el-select
                    class="col-md-12"
                    v-model="createLineItemForm.type"
                    placeholder="Select"
                    @change="setDevicesForAMP"
                >
                    <el-option v-for="item in placementType" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="p-t-1 of-auto">
                <h5>Geo</h5>
                <el-select
                    class="param-set-input select-input col-md-12"
                    v-model="selectedCountries"
                    multiple
                    placeholder="Select Country"
                    @change="validateUnique('country')"
                    v-validate="'required'"
                    name="Country"
                    filterable
                >
                    <el-option
                        v-for="country in countries"
                        :key="country.id"
                        :label="country.name"
                        :value="country.id"
                    ></el-option>
                </el-select>
                <span v-show="errors.has('Country')" class="help is-danger" style="color: red">{{
                    errors.first('Country')
                }}</span>
            </div>

            <div class="p-t-1 of-auto">
                <h5>Device</h5>
                <el-select
                    class="param-set-input select-input col-md-12"
                    multiple
                    v-model="selectedDevices"
                    placeholder="Select Device"
                    v-validate="'required'"
                    name="Devices"
                    @change="validateUnique('device')"
                >
                    <el-option
                        v-for="device in devices"
                        :key="device.id"
                        :label="device.name"
                        :value="device.id"
                        :disabled="disabledDevice.indexOf(device.id) > -1"
                    >
                    </el-option>
                </el-select>
                <span v-show="errors.has('Devices')" class="help is-danger" style="color: red">{{
                    errors.first('Devices')
                }}</span>
            </div>
            <div class="p-t-1 of-auto">
                <h5>Browser</h5>
                <el-select
                    class="param-set-input select-input col-md-12"
                    multiple
                    v-model="selectedBrowsers"
                    placeholder="Select Browsers"
                    v-validate="'required'"
                    name="Browsers"
                    @change="validateUnique('browser')"
                >
                    <el-option
                        v-for="browser in browsers"
                        :key="browser.id"
                        :label="browser.name"
                        :value="browser.id"
                        :disabled="disabledBrowser.indexOf(browser.id) > -1"
                    ></el-option>
                </el-select>
                <span v-show="errors.has('Browsers')" class="help is-danger" style="color: red">{{
                    errors.first('Browsers')
                }}</span>
            </div>

            <div class="p-t-1 of-auto">
                <h5>Dimension</h5>
                <div v-if="createLineItemForm.type.includes('tag')">
                    <el-select
                        v-model="selectedDimensions"
                        class="col-md-12"
                        placeholder="Select Dimensions"
                        v-validate="'required'"
                        name="Dimensions"
                        multiple
                        :multiple-limit="1"
                        @change="
                            validateUnique('dimension');
                            getAllPositionsForDimension($event);
                        "
                        @remove-tag="updateCreativeList(createLineItemForm, $event)"
                        filterable
                    >
                        <el-option
                            v-for="(dimension, index) in dimensions"
                            :key="index"
                            :label="`${dimension.width}X${dimension.height}`"
                            :value="dimension.id"
                            :disabled="disabledSize.indexOf(dimension.id) > -1"
                        ></el-option>
                    </el-select>
                    <span v-show="errors.has('Dimensions')" class="help is-danger" style="color: red">{{
                        errors.first('Dimensions')
                    }}</span>
                </div>
                <div v-else>
                    <el-select
                        v-model="selectedDimensions"
                        class="col-md-12"
                        placeholder="Select Dimensions"
                        v-validate="'required'"
                        name="Dimensions"
                        multiple
                        @change="
                            validateUnique('dimension');
                            getAllPositionsForDimension($event);
                        "
                        @remove-tag="updateCreativeList(createLineItemForm, $event)"
                        filterable
                    >
                        <el-option
                            v-for="(dimension, index) in dimensions"
                            :key="index"
                            :label="`${dimension.width}X${dimension.height}`"
                            :value="dimension.id"
                            :disabled="disabledSize.indexOf(dimension.id) > -1"
                        ></el-option>
                    </el-select>
                    <span v-show="errors.has('Dimensions')" class="help is-danger" style="color: red">{{
                        errors.first('Dimensions')
                    }}</span>
                </div>
            </div>

            <div class="p-t-1 of-auto">
                <h5>Creatives (<a target="_blank" href="https://scripts.atmtd.com/sib_preview/">Preview</a>)</h5>
                <div v-if="selectedDimensions.length > 0">
                    <div class="m-t-15 m-b-15" v-for="(dim, index) in selectedDimensions" :key="index">
                        <div class="dis-flex">
                            <span style="width: 75px"
                                >{{
                                    dimensions.length &&
                                    dimensions.filter((k) => k.id == dim)[0].width +
                                        'X' +
                                        dimensions.filter((k) => k.id == dim)[0].height
                                }}
                                -
                            </span>
                            <div style="width: 68%">
                                <el-select
                                    v-model="createLineItemForm.creativeIds[index]"
                                    class="col-md-12"
                                    placeholder="Select Creative"
                                    v-validate="'required'"
                                    name="Creatives"
                                    @change="addCreativeToLineItem(createLineItemForm, index)"
                                    filterable
                                >
                                    <el-option
                                        v-for="(creative, idx) in getCreativeList(dim)"
                                        :key="idx"
                                        :label="creative.name"
                                        :value="creative.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div
                            class="dis-flex"
                            v-if="createLineItemForm.creative.length > index && createLineItemForm.creative[index]"
                        >
                            <span style="width: 75px"></span>
                            <div
                                style="width: 68%; padding: 0 15px;"
                                v-if="createLineItemForm.creative[index].isS2S == true"
                            >
                                Tag ID :<el-input v-model="createLineItemForm.creative[index].tagId"></el-input>
                            </div>
                        </div>
                        <div
                            class="row"
                            style="border-bottom: 1px solid #ececec; padding-bottom: 19px"
                            v-if="
                                createLineItemForm.creative.length > index &&
                                createLineItemForm.creative[index] &&
                                createLineItemForm.creative[index].modify == true
                            "
                        >
                            <div class="col-md-3 p-t-15">
                                <div>Modified creative name:</div>
                                <el-input
                                    v-validate="'required|alpha_dash'"
                                    data-vv-delay="1000"
                                    class=""
                                    name="name"
                                    type="text"
                                    placeholder="Enter Creative Name"
                                    v-model="createLineItemForm.creative[index].name"
                                ></el-input>
                            </div>
                            <div class="col-md-2 p-t-15">
                                <div>Font-Size:</div>
                                <el-select filterable v-model="createLineItemForm.creative[index].font_size">
                                    <el-option
                                        v-for="(fontSize, index) in allFontSizes"
                                        :key="index"
                                        :label="fontSize"
                                        :value="fontSize"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-1">
                                <div>Font Color:</div>
                                <swatch
                                    v-model="createLineItemForm.creative[index].font_color"
                                    colors="text-advanced"
                                    popover-to="top"
                                    style="width: 50px; height: 50px"
                                    show-fallback
                                ></swatch>
                            </div>
                            <div class="col-md-1">
                                <div>CTA Color:</div>
                                <swatch
                                    v-model="createLineItemForm.creative[index].cta_color"
                                    colors="text-advanced"
                                    popover-to="top"
                                    style="width: 50px; height: 50px"
                                    show-fallback
                                ></swatch>
                            </div>
                            <div class="col-md-2">
                                <div>Background Color:</div>
                                <swatch
                                    v-model="createLineItemForm.creative[index].background_color"
                                    colors="text-advanced"
                                    popover-to="top"
                                    style="width: 50px; height: 50px"
                                    show-fallback
                                ></swatch>
                            </div>
                            <div class="creative-save-btn">
                                <el-button
                                    type="success"
                                    style="margin-top: 10px"
                                    @click="saveCreative(createLineItemForm.creative[index], index)"
                                    >Save</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>Select a dimension for creative association</div>
            </div>
            <div v-if="!isUniTag" class="p-t-1 of-auto">
                <h5>Placement</h5>
                <div
                    v-for="(data, index) in createLineItemForm.placements"
                    :key="`${index}positioninput`"
                    class="col-md-12 dis-flex"
                >
                    <el-select
                        clearable
                        @remove-tag="convertObjToRegex('placements')"
                        @change="convertObjToRegex('placements')"
                        v-model="createLineItemForm.placements[index].operator"
                        class="col-md-3"
                        style="padding: 0 5px 5px 0"
                        placeholder="Select an Operator"
                        v-validate="'required'"
                        name="Operator"
                        reserve-keyword
                        allow-create
                    >
                        <el-option
                            v-for="(operator, index) in [
                                ['Starts With', 'starts_with'],
                                ['Ends With', 'ends_with'],
                                ['Contains', 'contains'],
                                ['Equals', 'equals'],
                                ['Does Not Contain', 'does_not_contain'],
                            ]"
                            :key="index"
                            :label="operator[0]"
                            :value="operator[1]"
                        ></el-option>
                    </el-select>
                    <el-input
                        class="col-md-11"
                        style="margin: 0 5px 0 0; padding: 0px 5px 5px 5px"
                        v-validate="'required'"
                        data-vv-delay="1000"
                        name="placementName"
                        type="text"
                        placeholder="Enter Placement Name"
                        v-model="createLineItemForm.placements[index].data"
                        @remove-tag="convertObjToRegex('placements')"
                        @change="convertObjToRegex('placements')"
                    ></el-input>
                    <el-button
                        v-if="index === createLineItemForm.placements.length - 1"
                        style="height: 100%; text-align: center; padding-left: 0; padding-right: 0"
                        type="secondary"
                        class="col-md-1"
                        @click="
                            addNewItem(index, 'placements');
                            convertObjToRegex('placements');
                        "
                        >OR</el-button
                    >
                    <el-button
                        v-else
                        style="height: 100%; text-align: center; padding-left: 0; padding-right: 0"
                        type="danger"
                        class="col-md-1"
                        @click="
                            createLineItemForm.placements.splice(index, 1);
                            convertObjToRegex('placements');
                        "
                    >
                        <i class="fa fa-trash"></i>
                    </el-button>
                </div>
            </div>
            <div class="p-t-1 of-auto">
                <h5>Position</h5>
                <div
                    v-for="(data, index) in createLineItemForm.positions"
                    :key="`${index}positioninput`"
                    class="col-md-12 dis-flex"
                >
                    <el-select
                        clearable
                        @remove-tag="convertObjToRegex('positions')"
                        @change="convertObjToRegex('positions')"
                        v-model="createLineItemForm.positions[index].operator"
                        class="col-md-3"
                        style="padding: 0 5px 5px 0"
                        placeholder="Select an Operator"
                        v-validate="'required'"
                        name="Operator"
                        reserve-keyword
                        allow-create
                    >
                        <el-option
                            v-for="(operator, index) in [
                                ['Starts With', 'starts_with'],
                                ['Ends With', 'ends_with'],
                                ['Contains', 'contains'],
                                ['Equals', 'equals'],
                                ['Does Not Contain', 'does_not_contain'],
                            ]"
                            :key="index"
                            :label="operator[0]"
                            :value="operator[1]"
                        ></el-option>
                    </el-select>
                    <el-select
                        clearable
                        class="col-md-11"
                        style="margin: 0 5px 0 0; padding: 0px 5px 5px 5px"
                        v-model="createLineItemForm.positions[index].data"
                        allow-create
                        remote
                        :remote-method="positionFilter"
                        placeholder="Select or Add Position"
                        v-validate="'required'"
                        name="Positions"
                        @remove-tag="convertObjToRegex('positions')"
                        @change="convertObjToRegex('positions')"
                        :loading="positionsListLoading"
                        reserve-keyword
                        filterable
                    >
                        <el-option
                            v-for="(pos, index) in posOptions"
                            :key="index"
                            :label="pos"
                            :value="pos"
                        ></el-option>
                    </el-select>
                    <el-button
                        v-if="index === createLineItemForm.positions.length - 1"
                        style="height: 100%; text-align: center; padding-left: 0; padding-right: 0"
                        type="secondary"
                        class="col-md-1"
                        @click="
                            addNewItem(index, 'positions');
                            convertObjToRegex('positions');
                        "
                        >OR</el-button
                    >
                    <el-button
                        v-else
                        style="height: 100%; text-align: center; padding-left: 0; padding-right: 0"
                        type="danger"
                        class="col-md-1"
                        @click="
                            createLineItemForm.positions.splice(index, 1);
                            convertObjToRegex('positions');
                        "
                    >
                        <i class="fa fa-trash"></i>
                    </el-button>
                </div>
            </div>

            <div class="p-t-1 of-auto" v-if="createLineItemForm.type.includes('tag')">
                <h5>Bid CPM(USD):</h5>
                <el-input
                    type="text"
                    v-validate="'required|decimal:6'"
                    data-vv-delay="1000"
                    class="col-md-12"
                    name="Bid CPM(USD):"
                    v-model="createLineItemForm.bid_cpm_min"
                    :rows="10"
                    placeholder="Enter ECPM"
                ></el-input>
                <span v-show="errors.has('Bid CPM(USD) Min:')" class="help is-danger" style="color: red">{{
                    errors.first('Bid CPM(USD) Min:')
                }}</span>
            </div>
            <div v-else>
                <div class="p-t-1 of-auto">
                    <h5>Bid CPM(USD) Min:</h5>
                    <el-input
                        type="text"
                        v-validate="'required|decimal:6'"
                        data-vv-delay="1000"
                        class="col-md-12"
                        name="Bid CPM(USD) Min:"
                        v-model="createLineItemForm.bid_cpm_min"
                        :rows="10"
                        placeholder="Enter Min ECPM"
                    ></el-input>
                    <span v-show="errors.has('Bid CPM(USD) Min:')" class="help is-danger" style="color: red">{{
                        errors.first('Bid CPM(USD) Min:')
                    }}</span>
                </div>
                <div class="p-t-1 of-auto">
                    <h5>Bid CPM(USD) Max:</h5>
                    <el-input
                        type="text"
                        v-validate="'required|decimal:6'"
                        data-vv-delay="1000"
                        class="col-md-12"
                        name="Bid CPM(USD) Max:"
                        v-model="createLineItemForm.bid_cpm_max"
                        :rows="10"
                        placeholder="Enter Max ECPM"
                    ></el-input>
                    <span v-show="errors.has('Bid CPM(USD) Max:')" class="help is-danger" style="color: red">{{
                        errors.first('Bid CPM(USD) Max:')
                    }}</span>
                </div>
            </div>
            <div class="p-t-1 of-auto">
                <h5>Budget (USD):</h5>
                <el-input
                    type="text"
                    v-validate="'required|decimal:6'"
                    data-vv-delay="1000"
                    class="col-md-12"
                    name="Budget (USD):"
                    v-model="createLineItemForm.budget"
                    :rows="10"
                    placeholder="Enter Line item budget (USD)"
                ></el-input>
                <span v-show="errors.has('Budget (USD):')" class="help is-danger" style="color: red">{{
                    errors.first('Budget (USD):')
                }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="success"
                    @click="createLineItem($event)"
                    style="margin-top: 10px"
                    v-if="!isEditLineitem"
                    >Create Line item</el-button
                >
                <el-button type="success" style="margin-top: 10px" @click="createLineItem($event)" v-else
                    >Save</el-button
                >
            </span>
        </el-dialog>
        <el-dialog
            class="element-promt"
            title="Export Params"
            :visible.sync="showExportParamsDialog"
            width="40%"
            :before-close="handleCloseParama"
        >
            <div id="paramsDivId">
                <div>
                    <h4>Prebid Params:</h4>
                    <h5>siteId : {{ this.siteDetails.uuid }}</h5>
                    <h5 v-if="allLineItems.length !== 0">Placements:</h5>
                </div>
                <div
                    style="list-style-type: inherit"
                    v-for="(lItem, index) in mappedLineItemsByType['prebid']"
                    v-if="lItem.placement_text.length"
                    :key="index"
                >
                    <ol v-if="lItem.placement_text && lItem.placement_text.length" style="margin: 0">
                        <li v-for="(divt, index) in changeItemFormat(lItem.placement_text[0])" :key="index">
                            <span v-if="divt.data && divt.operator">
                                <span class="p-l-20"
                                    >Operator: {{ divt.hasOwnProperty('operator') && divt.operator }} , Value:
                                    {{ divt.data ? divt.data : divt }}</span
                                >
                            </span>
                        </li>
                    </ol>
                </div>
                <div v-if="mappedLineItemsByType['AMP'] && mappedLineItemsByType['AMP'].length > 0">
                    <hr v-if="mappedLineItemsByType['prebid'] && mappedLineItemsByType['prebid'].length > 0" />
                    <h4>RTC Urls:</h4>
                </div>
                <ol class="m-l-20">
                    <li
                        style="list-style-type: inherit"
                        v-for="(lItem, index) in mappedLineItemsByType['AMP']"
                        :key="index"
                    >
                        <div v-if="lItem.positions.length == 0">
                            Name: {{ lItem.placement_text[0] || '' }}
                            <div style="word-break: break-word; border-bottom: 1px solid #ececec">
                                {{
                                    siteDetails.currency
                                        ? rtcUrl
                                              .replace('SITEID', siteDetails.uuid)
                                              .replace('PLACEMENTID', lItem.placement_text[0] || '')
                                              .replace('POSITION', '')
                                              .replace('CURRENCY', siteDetails.currency.code)
                                        : rtcUrl
                                              .replace('SITEID', siteDetails.uuid)
                                              .replace('POSITION', '')
                                              .replace('PLACEMENTID', lItem.placement_text[0] || '')
                                              .split('&cur')[0]
                                }}
                            </div>
                        </div>
                        <div v-else v-for="(pos, id) in changeItemFormat(lItem.positions)" :key="id">
                            Name:
                            {{ lItem.placement_text[0] + ' - ' + pos.data ? pos.data : pos }}
                            <div style="word-break: break-word; border-bottom: 1px solid #ececec">
                                {{
                                    siteDetails.currency
                                        ? rtcUrl
                                              .replace('SITEID', siteDetails.uuid)
                                              .replace('PLACEMENTID', lItem.placement_text[0])
                                              .replace('POSITION', pos.data ? pos.data[0] : pos)
                                              .replace('CURRENCY', siteDetails.currency.code)
                                        : rtcUrl
                                              .replace('SITEID', siteDetails.uuid)
                                              .replace('POSITION', pos.data ? pos.data[0] : pos)
                                              .replace('PLACEMENTID', lItem.placement_text[0])
                                              .split('&cur')[0]
                                }}
                            </div>
                        </div>
                    </li>
                </ol>
            </div>
            <el-button type="success" @click="copiedToClipboardparams" style="margin-top: 10px">
                <i class="fa fa-clipboard" aria-hidden="true" style="color: white"></i>
                Copy To Clipboard
            </el-button>
        </el-dialog>
        <el-dialog
            class="element-promt"
            title="Export Tags"
            :visible.sync="showExportTagDialog"
            width="40%"
            :before-close="handleCloseTags"
        >
            <div v-if="tagSelectPosOptions.length > 0">
                <div id="paramsDivId">
                    <div v-for="(i, index) in tagSelectPosOptions" :key="index">
                        {{ index + 1 }}. size:
                        {{
                            dimensions.filter((k) => {
                                return k.id == i.size;
                            })[0].width +
                            'x' +
                            dimensions.filter((k) => {
                                return k.id == i.size;
                            })[0].height
                        }}, position: {{ i.positions }}, placement: {{ i.placement }}
                        <pre
                            ref="tag-code"
                            class="tag-code border border-gray-100"
                            style="
                                font-size: 12px;
                                margin-top: 0;
                                border-bottom-left-radius: 4px;
                                border-bottom-right-radius: 4px;
                            "
                        >
  <code class="language-html">
  &lt;script src=&quot;{{'https://scripts.atmtd.com/js/tag.js?cb=%%CACHEBUSTER%%'}}&quot; async&gt;&lt;/script&gt;
  &lt;script&gt;
        window.tagData = {};
        tagData.siteID = &quot;{{siteDetails.uuid}}&quot;;
        tagData.position = &quot;{{i.positions}}&quot;;
        tagData.size = &quot;{{dimensions.filter(k=>{return k.id == i.size})[0].width+'x'+dimensions.filter(k=>{return k.id == i.size})[0].height}}&quot;;
        tagData.placement = &quot;{{i.placement && "/*** Add placement params manually. ***/"}}&quot;;
        try {
          (function(){var intr=window.setInterval(function(){if(window.atmtdTag){window.clearInterval(intr);new atmtdTag(window.tagData);}});})();
        }
        catch (e) {
          console.log(e);
        }
  &lt;/script&gt;</code></pre>
                    </div>
                </div>
                <el-button type="success" @click="copiedToClipboardparams" style="margin-top: 10px">
                    <i class="fa fa-clipboard" aria-hidden="true" style="color: white"></i>
                    Copy To Clipboard
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/javascript" src="https://www.gstatic.com/charts/loader.js">
</script>
<script>
import axios from 'axios';
import Swatches from 'vue-swatches';
import VerEx from 'verbal-expressions';
import LineItemDetails from './AdspotDetails';
import LineItemData from './AdspotData';
import LineItemNotes from './AdspotNotes';
export default {
    components: {
        Swatch: Swatches,
        LineItemDetails,
        LineItemData,
        LineItemNotes,
    },
    data() {
        return {
            positionsRegexExpression: '',
            rtcUrl: 'https://bid.atmtd.com/request?placement_id=PLACEMENTID&site_id=SITEID&pos=POSITION&viewablity=BKG_STATE&w=ATTR(width)&h=ATTR(height)&ow=ATTR(data-override-width)&oh=ATTR(data-override-height)&ms=ATTR(data-multi-size)&slot=ATTR(data-slot)&curl=CANONICAL_URL&timeout=TIMEOUT&purl=HREF&cur=CURRENCY',
            tagText: '',
            positionsListLoading: false,
            allLineItems: [],
            mappedLineItemsByType: {},
            positionList: [],
            dimensionPos: {},
            note: "",
            notes: [],
            siteDetails: {
                uid: '',
                url: '',
                currency: null,
                publisher: '',
            },
            allFontSizes: [],
            showCreateLineitemDialog: false,
            showCreateLineItemNotes: false,
            showExportParamsDialog: false,
            showExportTagDialog: false,
            availableDimensions: [],

            placementType: ['AMP', 'prebid'],
            placementVertical: [],

            allGraph: [],

            domain_id: '',
            selectedItem: null,

            divTargettingNames: [],
            selecteddivTargettingNames: [],
            dimensions: [],
            countries: [],
            browsers: [],
            selectedBrowsers: [1, 2, 3, 4],
            selectedCountries: [],
            devices: [],
            selectedDevices: [1, 2, 3, 4, 5],

            tagSelectPos: '',
            tagSelectPosOptions: [],
            isUniTag: false,

            lineitemidEdit: '',
            LineItems: [],

            isEditLineitem: false,
            isLineItemNote: false,
            adspotIdPassToLineItems: undefined,

            selectedDimensions: [],
            selectedCreatives: [],
            creativeAssociation: {
                modify: false,
                font_size: '',
                font_color: '',
                font_family: '',
                name: '',
                background_color: '',
                cta_color: '',
                isS2S: false,
                tagId: '',
            },
            DivIdTargetingName: '',

            lineItemNote:{
                note: '',
                lineItemId: '',
            },
            createLineItemForm: {
                active: true,
                name: '',
                bid_cpm_min: '',
                bid_cpm_max: '',
                budget: '',
                messageBCountry: '',
                axt_refresh_time: 15,
                creative: [],
                creativeIds: [],
                tagIds: [],
                isDoubleCreative: false,
                vertical: '',
                placements: [{ data: '', operator: '' }],
                domain: '',
                type: '',
                positions: [{ data: '', operator: '' }],
            },
            creativeList: [],
            posOptions: [],

            adspotNativeClick: '',
            disabledDevice: [],
            disabledBrowser: [],
            disabledSize: [],

            earnSpendChart: [],
            chartWinsReponse: [],
            CPMRPM: [],
            allCaseId: '',

            totalReqResponse: [],
            loadingChart: false,
            dimensionTemp: [],
            dimensionsAsPerIsDoubleCreative: [],

            allRequestsResposes: [],
            currentAllDivIdTargetting: '',
            placementTotalReqRes: {
                hour: [0, 0, 0, 0, 0, 0, 0, 0],
                total_response: [0, 0, 0, 0, 0, 0, 0, 0],
                total_request: [0, 0, 0, 0, 0, 0, 0, 0],
            },
            isEventLoading: true,
            isRevenueLoading: true,
            timeNow: null

        };
    },
    created: function () {
        this.domain_id = this.$route.params;
        console.log('domid', this.domain_id.id, 'route', this.$route.params);
        console.log('all in created method', this.selecteddivTargettingNames.length);

        this.loadCreatives();
        this.loadAllLineItems();
        this.loadCountry();
        this.loadDevice();
        // this.loadAddimensions();
        this.loadBrowser();
        this.getDomain();
        // this.loadDivIdTargetting();
    },
    mounted: function () {
        console.log('all mounted', this.selecteddivTargettingNames.length);

        axios.get(BASE_URL + `bidder/v1/vertical-list/`).then((vertical) => {
            this.placementVertical = vertical.data;
        });
    },

    methods: {
   
        convertRegexToString(expr) {
            return expr.toString().replace('/', '').replace('/gm', '');
        },
        convertObjToRegex(type) {
            var obj = [];
            this.createLineItemForm[type].forEach((typeValue) => {
                if (typeValue.data.length && typeValue.operator.length) {
                    obj.push(typeValue);
                }
            });
            var final_regex = '';
            var expression = '';
            for (var i in obj) {
                if (obj[i].operator == 'starts_with') {
                    expression = VerEx().add('^' + obj[i]['data']);
                }
                if (obj[i].operator == 'ends_with') {
                    // expression=VerEx().endOfLine().find(obj[i]['data'])
                    expression = VerEx().add(obj[i]['data'] + '$');
                }
                if (obj[i].operator == 'equals') {
                    expression = VerEx().add('^' + obj[i]['data'] + '$');
                }
                if (obj[i].operator == 'contains') {
                    expression = VerEx().find(obj[i]['data']);
                }
                if (obj[i].operator == 'does_not_contain') {
                    expression = VerEx().add('^' + '(?' + '!.*' + obj[i]['data'] + ')' + '.*');
                }
                if (i == 0) {
                    final_regex = expression;
                } else {
                    final_regex = final_regex.or(expression);
                }
            }
            console.log('final_regex', final_regex);
            var fin = final_regex == '' ? '' : final_regex.toRegExp();
            // this.positionsRegexExpression = this.convertRegexToString(fin);
            this[type + 'RegexExpression'] = this.convertRegexToString(fin);
        },
        convertRegexToObj(expr) {
            var arr = expr.split('|');
            var regex_sanitize_expression = /[&\\#,+()!$~%.^'":*?<>{}]/g;
            var j = [];
            for (var i in arr) {
                if (arr[i].indexOf('^') > -1 && arr[i].indexOf('$') > -1) {
                    j.push({
                        data: arr[i].replace(regex_sanitize_expression, ''),
                        operator: 'equals',
                    });
                } else if (arr[i].indexOf('!') > -1) {
                    j.push({
                        operator: 'does_not_contain',
                        data: arr[i].replace(regex_sanitize_expression, ''),
                    });
                } else if (arr[i].indexOf('$') > -1) {
                    j.push({
                        operator: 'ends_with',
                        data: arr[i].replace(regex_sanitize_expression, ''),
                    });
                } else if (arr[i].indexOf('^') > -1) {
                    j.push({
                        operator: 'starts_with',
                        data: arr[i].replace(regex_sanitize_expression, ''),
                    });
                } else if (arr[i] == '') {
                    j.push({ operator: 'equals', data: '' });
                } else {
                    j.push({
                        operator: 'contains',
                        data: arr[i].replace(regex_sanitize_expression, ''),
                    });
                }
            }
            return j;
        },
        positionFilter(query) {
            if (query !== '') {
                this.positionsListLoading = true;
                this.posOptions = this.positionList.filter((item) => {
                    return item && item.indexOf(query) > -1;
                });
                this.positionsListLoading = false;
            } else {
                this.posOptions = [];
            }
        },
        getAllPositionsForDimension(dimension, existingPositionEntries = []) {
            if (dimension.length === 0) return;
            var dim = [];
            for (var i in dimension) {
                dim.push(
                    this.dimensions.filter((k) => {
                        return k.id == dimension[i];
                    })[0]
                );
            }

            var dimensions = dim.map((k) => {
                return k.width + 'x' + k.height;
            });
            axios
                .get(BASE_URL + `bidder/v1/domains/divids/?site_id=${this.siteDetails.uuid}&dimensions=${dimensions}`)
                .then((pos) => {
                    if (pos.hasOwnProperty('data')) {
                        this.positionList = pos.data;
                        if (existingPositionEntries.length > 0) {
                            for (var k in existingPositionEntries) {
                                if (
                                    this.positionList.map((x) => x.data).indexOf(existingPositionEntries[k].data) == -1
                                ) {
                                    this.positionList.push(existingPositionEntries[k].data);
                                }
                            }
                        }
                    }
                })
                .catch((err) => {
                    console.error('failed to fetch positions: ', err);
                });
        },
        getDomain() {
            const api1 = BASE_URL + `bidder/v1/domains/`+this.$route.params.id+'/';
            let vm = this;
            axios.get(api1).then(async (response) => {
                let currDomain = response.data;
                const publisherAPI = BASE_URL + `bidder/v1/publishers/${currDomain.publisher}/`;
                const res = await axios.get(publisherAPI);
                const publisher = res.data.name;
                vm.siteDetails = {...currDomain, publisher};
                vm.$forceUpdate();
            });
        },
        loadCreatives() {
            var apiCreatives = BASE_URL + 'bidder/v1/creatives/?limit=1000';
            axios.get(apiCreatives).then((creative) => {
                this.creativeList = creative.data.results;
                this.availableDimensions = [...new Set([].concat(...this.creativeList.map((k) => k.dimensions)))];
                this.loadAddimensions();
            });
        },
        saveCreative(creativeObj, id) {
            var creativeBase = this.creativeList.filter((k) => k.id == this.createLineItemForm.creativeIds[id])[0];
            if (creativeObj.name == '') {
                this.$notify({
                    title: 'error',
                    message: 'Assign a name to modified creative',
                    type: 'error',
                });
                return;
            }
            var toSaveCreative = Object.assign({}, creativeObj);
            toSaveCreative['keywords_count'] = creativeBase.keywords_count;
            toSaveCreative['sib_id'] = creativeBase.sib_id;
            delete toSaveCreative.modify;

            axios.post(BASE_URL + 'bidder/v1/creative/', toSaveCreative).then((res) => {
                console.log("Creative save successful", res);
            });
        },
        updateCreativeList(liObj, event, sl) {
            if (liObj.creative.length > 0) {
                var toremove = liObj.creative.findIndex((k) =>
                    k && k.hasOwnProperty('dimension') ? k.dimension.indexOf(event.currentValue) > -1 : false
                );

                this.$delete(liObj.creative, toremove);
                this.$delete(liObj.creativeIds, toremove);
            }
        },
        getCreativeList(dimId) {
            var crList = this.creativeList.filter((k) => k.dimensions.indexOf(dimId) > -1);
            console.log('crList: ' + crList.isS2S);
            console.log('Creative IDDDD: ' + crList[0].id);
            if (crList.length > 0) {
                return crList;
            }
            return [];
        },
        addCreativeToLineItem(lineItemObj, id) {
            var creativeObj = Object.assign({}, this.creativeAssociation);
            var creativeBase = this.creativeList.filter((k) => k.id == lineItemObj.creativeIds[id])[0];
            console.log('creativeBase.isS2S', creativeBase.isS2S);
            if (creativeBase.isS2S) {
                creativeObj.isS2S = creativeBase.isS2S;
            }
            if (creativeBase) {
                creativeObj.dimension = creativeBase.dimensions;
                this.$set(lineItemObj.creative, id, creativeObj);
            }
        },
        validateUnique(type = '') {
            let liList =
                this.isEditLineitem == true
                    ? this.LineItems.filter((k) => {
                          return k.id != this.lineitemidEdit;
                      })
                    : this.LineItems;

            let repeatedLineItem = '';

            liList.map((k) => {
                let dv = this.arrSubset(
                    this.selectedDevices,
                    k.device.map((v) => v)
                );
                let br = this.arrSubset(
                    this.selectedBrowsers,
                    k.browsers.map((v) => v)
                );
                let dm = this.arrSubset(
                    this.selectedDimensions,
                    k.dimensions.map((v) => v)
                );
                let ct = this.arrSubset(
                    this.selectedCountries,
                    k.country.map((v) => v)
                );
                let dit = this.arrSubset(
                    this.createLineItemForm.positions,
                    k.positions.map((v) => v)
                );
                if (dv == true && br == true && dm == true && ct == true && dit == true) {
                    repeatedLineItem = k.name;
                }
            });
            if (repeatedLineItem.length > 0) {
                this.$alert(
                    'Similar config exists with selected ' +
                        type +
                        ' for line item: <strong>' +
                        repeatedLineItem +
                        '</strong>',
                    'Error',
                    {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: 'OK',
                        callback: (action) => {
                            if (type == 'browser') {
                                this.selectedBrowsers.pop();
                            }
                            if (type == 'country') {
                                this.selectedCountries.pop();
                            }
                            if (type == 'device') {
                                this.selectedDevices.pop();
                            }
                            if (type == 'dimension') {
                                this.selectedDimensions.pop();
                            }
                            if (type == 'positions') {
                                this.createLineItemForm.positions.pop();
                            }
                        },
                    }
                );
            }
        },
        arrSubset(arr1, arr2) {
            let match = false;
            if (arr1.length > arr2.length) {
                match = arr2.filter((n) => arr1.includes(n)).length > 0;
            } else {
                match = arr1.filter((n) => arr2.includes(n)).length > 0;
            }
            return match;
        },
        closeLineitemContainer(currentLineItemID /* , adspotid */) {
            event.stopPropagation();

            this.allLineItems.map((res) => {
                if (res.id != currentLineItemID) {
                    var idLineitmContainerClose = res.id + 'LineitemContainer';
                    if (document.getElementById(idLineitmContainerClose)) {
                        document.getElementById(idLineitmContainerClose).style.display = 'none';
                    }
                }
            });
        },
        lineitemHeadingClick(lineitem) {
            console.log('lineitemHeadingClick');
            console.log(lineitem);
            this.tableDataEvent = [];
            this.tableDataRevenue = [];
            let apiEventData = ANALYTICS_BASE_URL + `api/v2/lineitem/event?xid=${lineitem.xid}` ;
            let apiRevenueData = ANALYTICS_BASE_URL + `api/v2/lineitem/revenue?xid=${lineitem.xid}` ;
            console.log(new Date().toISOString())
            setTimeout(() => {
                this.isEventLoading = true;
                this.isRevenueLoading = true;                    
                axios.get(apiEventData).then((response) => {
                    this.tableDataEvent = this.formatDateandTime(response.data);
                    this.timeNow = this.generateTime()
                    this.isEventLoading = false;
                });

                axios.get(apiRevenueData).then((response) => {
                    this.tableDataRevenue = this.formatDateandTime(response.data);                 
                    this.timeNow = this.generateTime()        
                    this.isRevenueLoading = false;            

                });  
            }, 500)

                            
            this.closeLineitemContainer(lineitem.id /* , selector */);

            this.allGraph = [];
            var idLineitmContainer = lineitem.id + 'LineitemContainer';

            if (document.getElementById(idLineitmContainer) != undefined) {
                document.getElementById(idLineitmContainer).style.display = 'block';
            }
            this.$forceUpdate();   
        },
        formatDateandTime(dateVal){
            for(let e of dateVal){
                let date = new Date(e.timeslot);
                let pstDate = date.toLocaleString('en-US', {
                    timeZone: 'America/Los_Angeles',
                });                
                console.log(pstDate)
                e.timeslot = pstDate;
                // e.timeslot = date.toISOString().replace('Z', ' ').replace('T', ' ');
            }
            return dateVal
        },
        generateTime(){
            let myDate = new Date();
            let pstDate = myDate.toLocaleString('en-US', {
                timeZone: 'America/Los_Angeles',
            });
            return pstDate;
        },
        lineitemStatus(item) {
            var apiEditlineitem = BASE_URL + 'bidder/v1/lineitems/' + item.id + '/';
            if (item.type.includes('tag')) {
                delete item.placement;
            }
            if (!item.placement) {
                delete item.placement;
            }
            if (typeof item.positions == 'object') item.positions = this.convertObjToRegex('positions');
            axios.put(apiEditlineitem, item).then((res) => {
                this.loadAllLineItems();
                this.getDomain();
            });
        },
        resumeExhaustedLineItem(event, lineitem) {
            event.stopPropagation();
            axios
                .post(BASE_URL + 'bidder/v1/lineitems/' + lineitem.id + '/resume_lineitem/', {})
                .then((response) => {
                    this.loadAllLineItems();
                })
                .catch((error) => {
                    console.log('error', error);
                });
        },
        resumeStage(event, lineitem) {
            event.stopPropagation();
            console.log('@&', lineitem);
            console.log('adspot', this.siteDetails.uuid);

            var x = {
                domain_uuid: this.siteDetails.uuid,
                placement_uuid: lineitem.placement.placement_id,
                creative_uid: lineitem.creative_uid,
                suspend: false,
            };
            console.log('@& resumeclick');
            var url = BASE_URL + 'bidder/v1/update-circuit-breaker/';

            axios.put(url, x).then((res) => {
                console.log('@&res circuit break', res);

                this.loadAllLineItems();
            });
        },
        lineitemDivClick(e) {
            e.stopPropagation();
        },
        copyToClipBoardLogic(elm) {
            if (document.body.createTextRange) {
                var range = document.body.createTextRange();
                range.moveToElementText(elm);
                range.select();
                document.execCommand('Copy');
            } else if (window.getSelection) {
                var selection = window.getSelection();
                var range = document.createRange();
                range.selectNodeContents(elm);
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand('Copy');
            }
        },
        copiedToClipboardparams() {
            console.log('params');
            var elm = document.getElementById('paramsDivId');
            this.copyToClipBoardLogic(elm);
        },
        showExportParamas() {
            this.showExportParamsDialog = true;
        },
        showExportTags() {
            var tags = this.allLineItems.filter((k) => {
                return k.type.includes('tag');
            });
            var formattedTags = [];
            if (tags.length > 0) {
                formattedTags = tags.map((k) => {
                    k.positions = this.changeItemFormat(k.positions ? k.positions : []);
                    return {
                        site: this.siteDetails.uuid,
                        positions:
                            k.positions[0] && k.positions[0].hasOwnProperty('data') ? k.positions[0].data : k.positions,
                        size: k.dimensions[0],
                        placement: k.placement_text[0],
                    };
                });

                const arr = formattedTags;
                let unique = [];
                for (let char of arr) {
                    let check = unique.find((e) => JSON.stringify(e) == JSON.stringify(char));
                    if (!check) {
                        unique.push(char);
                    }
                }
                this.tagSelectPosOptions = unique;
            }
            this.showExportTagDialog = true;
        },
        handleCloseTags() {
            this.showExportTagDialog = false;
        },
        handleCloseParama() {
            this.showExportParamsDialog = false;
        },
        copiedToClipboard(event, id, adspotid) {
            console.log('@@ite id', id, 'adspotid', adspotid);
            event.stopPropagation();
            let elmID = id + 'copy' + adspotid;
            var elm = document.getElementById(elmID);
            this.copyToClipBoardLogic(elm);
        },
        chartfu(lineitemid, chartData, whichChart) {
            google.charts.load('current', {
                packages: ['corechart'],
            });

            console.log('@@$% in chart earnSpendChart =  ', chartData, 'which chart', whichChart);

            // Set a callback to run when the Google Visualization API is loaded.
            google.charts.setOnLoadCallback(drawChart);

            // Callback that creates and populates a data table,
            // instantiates the pie chart, passes in the data and
            // draws it.
            function drawChart() {
                //for data table
                var datae = [];
                let temp = [];
                //configuration
                var title = '';
                var colors = [];

                switch (whichChart) {
                    case 1:
                        temp.push('vAxis');
                        temp.push('Earn(AXT)');
                        temp.push({ type: 'boolean', role: 'certainty' });
                        temp.push('Earn(FI)');
                        temp.push({ type: 'boolean', role: 'certainty' });
                        temp.push('Spend');
                        temp.push({ type: 'boolean', role: 'certainty' });

                        datae.push(temp);

                        for (var i = 0; i < chartData.x.length; i++) {
                            let temp = [];

                            var to = chartData.x[i] + 1;

                            temp.push(chartData.x[i] + '-' + to);
                            temp.push(chartData.total_earn_axt[i]);
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }
                            temp.push(chartData.total_earn_fi[i]);

                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }

                            temp.push(chartData.total_spent[i]);
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }

                            datae.push(temp);
                        }
                        //configuration

                        title = 'Earn / Spend $';
                        colors = ['#11ab16', 'green', 'red'];
                        break;
                    case 2:
                        let winRate = '';
                        let impressionRate = '';
                        temp.push('Hours');
                        temp.push('Responses');
                        temp.push({ type: 'string', role: 'tooltip' });
                        temp.push({ type: 'boolean', role: 'certainty' });
                        temp.push('Wins');
                        temp.push({ type: 'string', role: 'tooltip' });
                        temp.push({ type: 'boolean', role: 'certainty' });
                        temp.push('Impressions');

                        temp.push({ type: 'string', role: 'tooltip' });
                        temp.push({ type: 'boolean', role: 'certainty' });
                        // temp.push('WinRate = wins/responses')
                        //temp.push('impressions/wins')

                        datae.push(temp);

                        for (var i = 0; i < chartData.x.length; i++) {
                            let temp = [];

                            var to = chartData.x[i] + 1;

                            winRate = chartData.wins[i] / chartData.responses[i];
                            impressionRate = chartData.impressions[i] / chartData.wins[i];
                            winRate = winRate.toFixed(2);
                            impressionRate = impressionRate.toFixed(2);

                            temp.push(chartData.x[i] + '-' + to);
                            temp.push(chartData.responses[i]);
                            temp.push(
                                'Reponses :' +
                                    chartData.responses[i] +
                                    ' WinRate :' +
                                    winRate +
                                    ' Impressions/Wins:' +
                                    impressionRate
                            );
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }
                            temp.push(chartData.wins[i]);
                            temp.push(
                                'Wins :' +
                                    chartData.wins[i] +
                                    ' WinRate :' +
                                    winRate +
                                    ' Impressions/Wins:' +
                                    impressionRate
                            );
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }
                            temp.push(chartData.impressions[i]);
                            temp.push(
                                'Impression :' +
                                    chartData.impressions[i] +
                                    ' WinRate :' +
                                    winRate +
                                    '  Impressions/Wins:' +
                                    impressionRate
                            );
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }
                            // temp.push();
                            //  temp.push(chartData.impressions[i]/chartData.wins[i]);

                            datae.push(temp);
                        }
                        //configuration
                        title = 'Wins / Responses / Impressions';
                        colors = ['orange', '#edbc91', '#cc0000', 'red'];

                        break;
                    case 3:
                        temp.push('Hours');
                        temp.push('Cpm');
                        temp.push({ type: 'boolean', role: 'certainty' });
                        temp.push('Rpm');
                        temp.push({ type: 'boolean', role: 'certainty' });

                        datae.push(temp);

                        for (var i = 0; i < chartData.x.length; i++) {
                            let temp = [];

                            var to = chartData.x[i] + 1;

                            temp.push(chartData.x[i] + '-' + to);

                            temp.push(chartData.cpm[i]);
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }
                            temp.push(chartData.rpm[i]);
                            if (i == 0) {
                                temp.push(false);
                            } else {
                                temp.push(true);
                            }

                            datae.push(temp);
                        }
                        //configuration
                        title = 'CPM / RPM $';
                        colors = ['#9b7aa3', '#f224d7'];
                        break;
                }

                var tdata = new google.visualization.arrayToDataTable(datae);

                // Set chart options
                var width = 100 + '%';

                var options = {
                    title: title,
                    width: width,
                    height: 300,
                    colors: colors,
                    vAxis: {
                        viewWindow: {
                            min: 0,
                        },
                    },

                    // 'vAxis.viewWindow.min' :  0
                };

                // Instantiate and draw our chart, passing in some options.
                var chart = new google.visualization.ColumnChart(document.getElementById(lineitemid));
                chart.draw(tdata, options);
            }
        },
        changeItemFormat(e) {
            if (typeof e == 'string') {
                if (e.indexOf('{') > -1 && e.indexOf('}') > -1) {
                    e = e.replace('{', '').replace('}', '').split(',');
                } else {
                    e = this.convertRegexToObj(e);
                }
            }
            if (e && e.length && typeof e[0] == 'string') {
                e = e.map((x) => {
                    return { data: x, operator: 'equals' };
                });
            }
            return e;
        },
        loadDevice() {
            var apiDevice = BASE_URL + 'bidder/v1/device-list/';
            axios.get(apiDevice).then((response) => {
                console.log('respomse of device', response.data);
                this.devices = [];
                this.devices.push(...response.data);
            });
        },
        loadBrowser() {
            var apiBrowser = BASE_URL + 'bidder/v1/browser-list/';
            axios.get(apiBrowser).then((response) => {
                console.log('@@respomse of browser-list', response.data);
                this.browsers = [];
                this.browsers.push(...response.data);
            });
        },
        loadCountry() {
            var apiCountry = BASE_URL + 'v1/countries/';
            axios.get(apiCountry).then((response) => {
                this.countries = [];
                this.countries.push(...response.data);
            });
        },
        addNewItem(index, type) {
            let temp = this.createLineItemForm[type][index];
            if (temp.data.length && temp.operator.length) {
                this.createLineItemForm[type].push({ data: '', operator: '' });
            } else {
                this.$notify({
                    title: 'Error',
                    message: 'Input must have a value',
                    type: 'error',
                });
            }
        },
        setDevicesForAMP() {
            // for amp, by default only mobile devices selected
            if (this.createLineItemForm.type == 'AMP') {
                this.selectedDevices = [1, 2];
            } else {
                this.selectedDevices = [1, 2, 3, 4, 5];
            }
        },
        showCreateLineItemNotesfunction(){
            event.stopPropagation();
            this.showCreateLineItemNotes = true;
        },
        showCreateLineitemDialogfunction(event /*, id */) {
            event.stopPropagation();

            this.loadAddimensions();
            this.loadBrowser();
            // this.loadDivIdTargetting();

            this.createLineItemForm.messageBCountry = '';
            // this.displayexistingcountries = [];
            this.isEditLineitem = false;
            this.createLineItemForm.name = '';
            this.createLineItemForm.bid_cpm_min = '';
            this.createLineItemForm.bid_cpm_max = '';
            this.createLineItemForm.budget = '';
            this.createLineItemForm.vertical = '';

            this.createLineItemForm.domain = this.domain_id.id;
            this.createLineItemForm.type = 'prebid';
            this.createLineItemForm.positions = [{ data: '', operator: '' }];
            this.createLineItemForm.placements = [{ data: '', operator: '' }];

            this.createLineItemForm.active = true;

            this.createLineItemForm.selectedCreative = 1;
            this.selectedCountries = [];

            this.selectedDevices = [1, 2, 3, 4, 5];
            this.selectedBrowsers = [1, 2, 3, 4];
            this.selectedDimensions = [];
            this.createLineItemForm.creativeIds = [];
            this.createLineItemForm.tagIds = [];
            this.isUniTag = false;

            this.showCreateLineitemDialog = true;

            this.disabledDevice = [];
            this.disabledBrowser = [];
            this.disabledSize = [];
            if (this.createLineItemForm.isDoubleCreative) {
                this.dimensions = this.dimensionsAsPerIsDoubleCreative;
            } else {
                this.dimensions = this.dimensionTemp;
            }
        },        
        showCreateTagDialogfunction(event) {
            event.stopPropagation();

            this.loadAddimensions();
            this.loadBrowser();
            // this.loadDivIdTargetting();

            this.createLineItemForm.messageBCountry = '';
            // this.displayexistingcountries = [];
            this.isEditLineitem = false;
            this.createLineItemForm.name = '';
            this.createLineItemForm.bid_cpm_min = '';
            this.createLineItemForm.bid_cpm_max = '';
            this.createLineItemForm.budget = '';
            this.createLineItemForm.vertical = '';

            this.createLineItemForm.domain = this.domain_id.id;
            this.createLineItemForm.type = 'tag';
            this.createLineItemForm.positions = [{ data: '', operator: '' }];
            this.createLineItemForm.placements = [{ data: '', operator: '' }];

            this.createLineItemForm.active = true;

            this.createLineItemForm.selectedCreative = 1;
            this.selectedCountries = [];

            this.selectedDevices = [1, 2, 3, 4, 5];
            this.selectedBrowsers = [1, 2, 3, 4];
            this.selectedDimensions = [];
            this.createLineItemForm.creativeIds = [];
            this.isUniTag = false;

            this.showCreateLineitemDialog = true;

            this.disabledDevice = [];
            this.disabledBrowser = [];
            this.disabledSize = [];
            if (this.createLineItemForm.isDoubleCreative) {
                this.dimensions = this.dimensionsAsPerIsDoubleCreative;
            } else {
                this.dimensions = this.dimensionTemp;
            }
        },
        editDuplicateCommon(litemobj) {
            this.createLineItemForm.messageBCountry = '';
            this.showCreateLineitemDialog = true;
            this.isUniTag = litemobj.type == 'unitag' ? true : false;
            this.createLineItemForm.name = litemobj.name;
            this.createLineItemForm.bid_cpm_min = litemobj.bid_cpm_min;
            this.createLineItemForm.bid_cpm_max = litemobj.bid_cpm_max;
            this.createLineItemForm.active = litemobj.active;
            this.createLineItemForm.isDoubleCreative = litemobj.is_double_creative;
            this.createLineItemForm.budget = litemobj.budget;
            this.createLineItemForm.vertical = litemobj.vertical;

            litemobj.positions = this.changeItemFormat(litemobj.positions);
            litemobj.placements = this.changeItemFormat(
                litemobj.placement_text.length ? litemobj.placement_text[0] : ['']
            );

            this.createLineItemForm.placements = litemobj.placements;
            this.createLineItemForm.positions = litemobj.positions;

            this.createLineItemForm.domain = litemobj.domain;
            this.createLineItemForm.type = litemobj.type;

            this.createLineItemForm.axt_refresh_time = litemobj.axt_refresh_time;

            this.selectedBrowsers = [];
            for (let i = 0; i < litemobj.browsers.length; i++) {
                this.selectedBrowsers.push(litemobj.browsers[i]);
            }

            this.selectedDimensions = [];
            for (let i = 0; i < litemobj.dimensions.length; i++) {
                this.selectedDimensions.push(litemobj.dimensions[i]);
            }
            this.getAllPositionsForDimension(this.selectedDimensions, litemobj.positions);
            for (let i = 0; i < litemobj.creative.length; i++) {
                var l = this.creativeList.filter((k) => k.id == litemobj.creative[i]);
            }
            this.createLineItemForm.creativeIds = Object.assign([], litemobj.creative);

            if (this.createLineItemForm.creativeIds.length > 1) {
                var arr = [...this.selectedDimensions];
                this.createLineItemForm.creativeIds.sort(
                    (a, b) =>
                        arr.indexOf(this.creativeList.filter((k) => k.id == a)[0].dimensions[0]) -
                        arr.indexOf(this.creativeList.filter((k) => k.id == b)[0].dimensions[0])
                );
            }
            this.selectedDimensions.map((val, index) => {
                this.addCreativeToLineItem(this.createLineItemForm, index);
            });

            if (litemobj.tag_ids.length > 0) {
                litemobj.tag_ids.map((k) => {
                    this.createLineItemForm.creative[this.createLineItemForm.creativeIds.indexOf(k.creative)].tagId =
                        k.tag_id;
                });
            }

            this.selectedCountries = [];

            for (let i = 0; i < litemobj.country.length; i++) {
                this.selectedCountries.push(litemobj.country[i]);
            }

            this.selectedDevices = [];
            for (let j = 0; j < litemobj.device.length; j++) {
                console.log('@@$%', litemobj.device[j]);
                this.selectedDevices.push(litemobj.device[j]);
            }
            this.selecteddivTargettingNames = [];
            if (this.createLineItemForm.isDoubleCreative) {
                this.dimensions = this.dimensionsAsPerIsDoubleCreative;
            } else {
                this.dimensions = this.dimensionTemp;
            }
            this.showCreateLineitemDialog = true;
        },
        createLineItemNotes(event, item) {
            event.stopPropagation();
            console.log(item);
            // this.showLineItemNotes = true;
            this.showCreateLineItemNotes = true;
            this.selectedItem = item.id;
        },
        editLineitem(event, litemobj) {
            event.stopPropagation();
            console.log('click open');
            console.log('@@$%lineitemobj', litemobj);
            this.isEditLineitem = true;
            this.lineitemidEdit = litemobj.id;
            this.editDuplicateCommon(litemobj);
            console.log('FFFFFFFFFFFFF', this.isEditLineitem);
            console.log('final debug', this.createLineItemForm);
        },
        showDuplicateLineitemDialogfunction(event, litemobj /*, id */) {
            event.stopPropagation();
            console.log('@@$%lineitemobj', litemobj);
            this.isEditLineitem = false;
            this.editDuplicateCommon(litemobj);
        },
        createLineItem(event) {
            event.stopPropagation();
            this.createLineItemForm.tagIds = this.createLineItemForm.creative
                .map((k, index) => {
                    if (k.tagId.length > 0) {
                        return {
                            tag_id: k.tagId,
                            creative: this.createLineItemForm.creativeIds[index],
                        };
                    }
                })
                .filter((k) => {
                    return k != null;
                });
            if (this.createLineItemForm.type.includes('tag')) {
                if (this.createLineItemForm.bid_cpm_min.length > 0) {
                    this.createLineItemForm.bid_cpm_max = this.createLineItemForm.bid_cpm_min;
                }

                if (this.isUniTag == true) {
                    this.createLineItemForm.type = 'unitag';
                } else {
                    this.createLineItemForm.type = 'tag';
                }
            }

            if (this.createLineItemForm.vertical.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter line item vertical',
                    type: 'error',
                });
                return;
            }

            if (this.selectedDevices.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select devices',
                    type: 'error',
                });
                return;
            }
            if (this.selectedCountries.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select a country',
                    type: 'error',
                });
                return;
            }
            if (this.selectedDimensions.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select Dimensions',
                    type: 'error',
                });
                return;
            }
            if (this.selectedBrowsers.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please Select browsers',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.bid_cpm_min.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter minimum bidcpm',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.bid_cpm_max.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter maximum bidcpm',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.bid_cpm_max < this.createLineItemForm.bid_cpm_min) {
                this.$notify({
                    title: 'error',
                    message: 'Max bid cpm cannot be less than Min bid cpm',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.budget.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter line item budget',
                    type: 'error',
                });
                return;
            }
            if (this.createLineItemForm.creativeIds.length != this.selectedDimensions.length) {
                this.$notify({
                    title: 'error',
                    message: 'Make sure all selected dimensions have creatives associated',
                    type: 'error',
                });
                return;
            }

            if (this.createLineItemForm.name.length == 0) {
                this.$notify({
                    title: 'error',
                    message: 'Please enter line item name',
                    type: 'error',
                });
                return;
            }

            if (this.domain_id) {
                var apiCreateLineitem = BASE_URL + 'bidder/v1/lineitems/';

                var apiEditLineitem = BASE_URL + 'bidder/v1/lineitems/' + this.lineitemidEdit + '/';
            }

            if (this.createLineItemForm.isDoubleCreative == true && this.selectedDimensions.length > 1) {
                this.$notify({
                    title: 'error',
                    message: 'Only one dimension can be selected when double creative is enabled',
                    type: 'error',
                });
                return;
            }
            console.log('@@', ...this.selectedBrowsers);
            console.log('@@', ...this.selectedDimensions);

            this.convertObjToRegex('positions');
            this.convertObjToRegex('placements');

            let LineitemObject = {
                name: this.createLineItemForm.name,
                active: this.createLineItemForm.active,
                country: this.selectedCountries,
                device: this.selectedDevices,
                div_ids: this.selecteddivTargettingNames,
                // creative: this.createLineItemForm.selectedCreative,

                bid_cpm_min: this.createLineItemForm.bid_cpm_min,
                bid_cpm_max: this.createLineItemForm.bid_cpm_max,
                budget: this.createLineItemForm.budget,

                // placement:this.createLineItemForm.placement,
                axt_refresh_time: parseInt(this.createLineItemForm.axt_refresh_time),
                browsers: this.selectedBrowsers,
                dimensions: this.selectedDimensions,
                is_double_creative: this.createLineItemForm.isDoubleCreative,
                creative: this.createLineItemForm.creativeIds,
                vertical: this.createLineItemForm.vertical,
                domain: this.createLineItemForm.domain,
                tag_ids: this.createLineItemForm.tagIds,
                type: this.createLineItemForm.type,
                placement_text:
                    typeof this.createLineItemForm.placements == 'object'
                        ? [this.placementsRegexExpression]
                        : [this.createLineItemForm.placements],
                positions:
                    typeof this.createLineItemForm.positions == 'object'
                        ? this.positionsRegexExpression
                        : this.createLineItemForm.positions,
            };
            if (LineitemObject.placement_text[0] == '') {
                LineitemObject.placement_text = [];
            }

            if (LineitemObject.type == 'unitag') {
                delete LineitemObject.placement_text;
            }

            if (this.isEditLineitem) {
                axios
                    .put(apiEditLineitem, LineitemObject)
                    .then((response) => {
                        this.$notify({
                            title: 'success',
                            message: 'Successfully Updated Lineitem',
                            type: 'success',
                        });
                        this.LineItems = [];
                        this.loadAllLineItems();

                        this.isEditLineitem = false;
                        this.lineitemidEdit = '';
                        this.showCreateLineitemDialog = false;

                        this.createLineItemForm.name = '';
                        this.createLineItemForm.bid_cpm_min = '';
                        this.createLineItemForm.bid_cpm_max = '';
                        this.createLineItemForm.active = false;
                        this.createLineItemForm.selectedCreative = 1;
                        this.createLineItemForm.budget = '';
                        this.createLineItemForm.positions = [{ data: '', operator: '' }];
                        this.createLineItemForm.tagIds = [];
                        this.positionsRegexExpression = '';
                        this.selectedCountries = [];
                        this.selectedDevices = [];

                        this.selectedDimensions = [];
                        this.selectedBrowsers = [];
                        this.isUniTag = false;
                        this.getDomain();// So that currDomain variable is updated to update inactive li's
                    })
                    .catch((err) => {
                        console.log(err, err.response);
                        if (typeof this.createLineItemForm.positions != 'object') {
                            this.createLineItemForm.positions = this.convertRegexToObj(
                                this.createLineItemForm.positions
                            );
                        }
                        this.$notify({
                            title: 'error',
                            message:
                                err.response.hasOwnProperty('data') && err.response.data.hasOwnProperty('message')
                                    ? err.response.data.message
                                    : 'Something went wrong. Please try again in sometime',
                            type: 'error',
                        });
                    });
                return;
            }
            axios
                .post(apiCreateLineitem, LineitemObject)
                .then((response) => {
                    this.showCreateLineitemDialog = false;
                    this.$notify({
                        title: 'success',
                        message: 'Successfully Created Lineitem',
                        type: 'success',
                    });
                    this.LineItems = [];
                    this.mappedLineItemsByType = {};
                    this.loadAllLineItems();

                    this.createLineItemForm.bid_cpm_min = '';
                    this.createLineItemForm.bid_cpm_max = '';
                    this.createLineItemForm.budget = '';
                    this.createLineItemForm.active = false;
                    this.createLineItemForm.selectedCreative = 1;
                    this.selectedCountries = [];
                    this.selectedDevices = [];
                    this.positionsRegexExpression = '';
                    this.createLineItemForm.positions = [{ data: '', operator: '' }];

                    this.selectedBrowsers = [];
                    this.selectedDimensions = [];
                    this.getDomain();// So that currDomain variable is updated to update inactive li's
                })
                .catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'error',
                        message: err.response.data.hasOwnProperty('message')
                            ? err.response.data.message
                            : 'Something went wrong. Please try again in sometime',
                        type: 'error',
                    });
                });
        },
        loadAddimensions() {
            this.dimensionsAsPerIsDoubleCreative = [];
            var apidimension = BASE_URL + 'v1/ad-dimensions/';
            var dim = [
                '300x250',
                '320x50',
                '728x90',
                '970x90',
                '250x250',
                '300x50',
                '320x100',
                '336x280',
                '320x480',
                '970x250',
                '300x600',
                '320x250',
            ];
            axios.get(apidimension).then((response) => {
                //console.log("dimensions", response.data);
                let dimensions = response.data;

                this.dimensions = dimensions.filter((m) => this.availableDimensions.indexOf(m.id) > -1);
                this.dimensionTemp = dimensions.filter((m) => this.availableDimensions.indexOf(m.id) > -1);

                for (var i = 0; i < this.dimensions.length; i++) {
                    if (
                        (this.dimensions[i].width == 300 && this.dimensions[i].height == 600) ||
                        (this.dimensions[i].width == 970 && this.dimensions[i].height == 250) ||
                        (this.dimensions[i].width == 336 && this.dimensions[i].height == 280) ||
                        (this.dimensions[i].width == 300 && this.dimensions[i].height == 250)
                    ) {
                        this.dimensionsAsPerIsDoubleCreative.push(this.dimensions[i]);
                    }
                }

                console.log('this.dimensionsAsPerIsDoubleCreative', this.dimensionsAsPerIsDoubleCreative);
            });
        },
        loadAllLineItems() {
            var apiLineItems = BASE_URL + 'bidder/v1/lineitems/?domain=' + this.domain_id.id + '&limit=1000';
            axios
                .get(apiLineItems)
                .then((lineItems) => {
                    let lineItemList = lineItems.data.results;
                    this.mappedLineItemsByType = {};
                    lineItemList.forEach((item) => {
                        if (this.mappedLineItemsByType[item.type]) {
                            this.mappedLineItemsByType[item.type].push(item);
                        } else {
                            this.mappedLineItemsByType[item.type] = [item];
                        }
                    });

                    this.allLineItems = lineItemList;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleCloseLineitem() {
            this.showCreateLineitemDialog = false;
        },
        handleCloseLineItemNotes() {
            this.showCreateLineItemNotes = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// Adspotofbidders.vue?21f14e26